import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateTramiteRegistroRequest, IGetTramitesSolicitudUsuario } from '../shared/interfaces/liquidacion';
import {
  IDescripcionTramite,
  IInfoRecaudoTramite,
  IResumenSolicitud
} from "../shared/interfaces/tramite";
import { API_URL } from 'lib-base';


@Injectable({
  providedIn: 'root'
})
export class TramRegistroSolicitudService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tram-registro-solicitud`;
  }

  createTramiteSolicitud(request: CreateTramiteRegistroRequest): Observable<number> {
    return this.http.post<number>(`${this.baseUrl}`, request);
  }

  getTramitesSolicitudUsuario(): Observable<IGetTramitesSolicitudUsuario[]> {
    return this.http.get<IGetTramitesSolicitudUsuario[]>(`${this.baseUrl}/solicitud-usuario`);
  }

  getSolicitudPendienteReciente(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/solicitud-usuario/pendiente`);
  }

  getResumenSolicitud(solicitud:number):Observable<IResumenSolicitud>{
   const url = `${this.baseUrl}/resumen-solicitud`;
   const params = new HttpParams().set('solicitud', solicitud);
   return this.http.get<IResumenSolicitud>(url, {params: params});
  }

  getDescripcion(solicitud:number): Observable<IDescripcionTramite> {
    const url = `${this.baseUrl}/descripcion`;
    const params:HttpParams = new HttpParams().set('solicitud',solicitud);
    return this.http.get<IDescripcionTramite>(url,  {params:params})
  }

  getRadicado(solicitud: number): Observable<number> {
    const url = `${this.baseUrl}/radicado`;
    const params: HttpParams = new HttpParams().set('solicitud', solicitud);
    return this.http.get<number>(url, {params: params})
  }

  hasFuentePago(solicitud: number): Observable<string> {
    const params: HttpParams = new HttpParams().set('solicitud', solicitud);
    return this.http.get(`${this.baseUrl}/fuente-pago`, {params: params, responseType:'text'})
  }

  tieneTramiteActivo(tipoTramiteId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/tiene-tramite-activo/${tipoTramiteId}`);
  }

  cancelarSolicitud(solicitud:number) {
    return this.http.put(`${this.baseUrl}/desactivar/${solicitud}`, {});
  }

  getInfoRecaudoTramite(solicitud:number): Observable<IInfoRecaudoTramite> {
    return this.http.get<IInfoRecaudoTramite>(`${this.baseUrl}/info-recaudo/tramite/${solicitud}`);
  }
}
